import type { Numeric } from 'decimal.js-light';
import Decimal from 'decimal.js-light';

import { cleanRawDecimalValue } from './clean-raw-decimal-value';
import { groupDigits } from './group-digits';

/**
 * Format a number with thousands separators.
 *
 * @param value The value to format. Accepts string, number, or Decimal.
 * @param dp Decimal places. Defaults to `0`.
 *
 * @example
 * formatFixed(1234.567)     // returns '1,234'
 * formatFixed(1234.567, 2)  // returns '1,234.57'
 * formatFixed(-1234.59, 2)  // returns '-1,234.59'
 * formatFixed('12345.6', 3) // returns '12,345.600'
 */
export function formatFixed(value: Numeric, dp = 0): string {
	// eslint-disable-next-line unicorn/prefer-number-properties
	if (isNaN(value as number)) {
		return '';
	}
	return groupDigits(new Decimal(cleanRawDecimalValue(value)).toFixed(dp));
}
